import React from "react";
import { FilterBodyItem } from "./components/filterBodyItem/filterBodyItem.index";
import { FilterOption } from "../../filterPopup.models";
import styles from "./filterBody.module.css";

interface FilterBodyProps {
    filterOptions: FilterOption[];
}

export const FilterBody = ({ filterOptions }: FilterBodyProps) => (
    <div className={styles.filterBodyCtn}>
        <div className={styles.filterBodyItemCtn}>
            {filterOptions.map((option) => (
                <FilterBodyItem key={option.label} filterOptions={option} />
            ))}
        </div>
    </div>
);
